import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";

import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import PermissionCheck from '../Permissions/PermissionCheck';
import Grid from '../Helper/Grid';

import CapteurParametre from './CapteurParametre';

import ListeDiffusion from './ListeDiffusion';
import ControlledGrid from '../Helper/ControlledGrid';
/**
* Class Capteur
* Capteur view component
**/
class Capteur extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Capteur";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    let dateService = null;
    if(this.state.object.dateService) {

      dateService = this.state.object.dateService;

      if(typeof dateService === "string") {
        dateService = getDateFromString(dateService);
      }

      dateService = getIsoStringFromDate(dateService);
    }







    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="capteurForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du capteur.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idCapteur" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idCapteur")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="nom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text"  onChange={this.handleChange} value={this.getObjectProperty("nom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>


          <FormGroup controlId="url">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Lien URL</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("url")} disabled={this.getReadOnly()} /></Col>
            <Col sm={2}>
              <Button bsStyle="primary" onClick={this.openLink.bind(this)}>Lien</Button>
            </Col>
          </FormGroup>


          <FormGroup controlId="lastdate">
              <Col componentClass={ControlLabel} sm={2}><ControlLabel>Dernier relevé</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" value={this.geteDateTime(this.getObjectProperty("lastdate"))} disabled={true}/></Col>
          </FormGroup>

{/*
          <FormGroup controlId="info">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Information</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("info")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="type">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Type</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("type")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="modele">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Modèle</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("modele")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="fabricant">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Fabricant</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("fabricant")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>


          <FormGroup controlId="dateService">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Date mise en service</ControlLabel></Col>
            <Col sm={6}><DatePicker id="dateService" dateFormat="DD/MM/YYYY" value={dateService} onChange={this.handleDateServiceChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="statut">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Statut</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("statut")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>
*/}

          {/* ListeDiffusion ManyToMany */}
          <PermissionCheck component={ListeDiffusion.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="listeDiffusions">
            <Col componentClass={ControlLabel} sm={2}>Listes de diffusion</Col>
            <Col sm={6}>
              <ControlledGrid ref="listeDiffusionsGrid" path="listediffusions" objectPath={"capteurs_listediffusions/" + this.state.object.idCapteur + "/listediffusions"} objectClass={ListeDiffusion} mode={this.state.mode} cbxUrl={REST_API_URL + "capteurs_listediffusions/" + this.state.object.idCapteur + "/listediffusions/inverse/"} optionValueKey="idListeDiffusion" optionLabelKey="libelle" disableAdd={true} />
            </Col>
            </FormGroup>
          </PermissionCheck>


          {/* CapteurParametre OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={CapteurParametre.getClassName()} permission={PERMISSION_READ}>
              <Grid ref="capteurParametreGrid" title="Paramètre" path="capteurParametres" objectPath={"capteurs/" + this.getObjectProperty("idCapteur") + "/capteurParametres"}
              objectClass={CapteurParametre} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }


          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * onCommuneSelect
  * Modify the state idCommune property from idCommune Combobox change
  **/
  onCommuneSelect(commune) {
    let objState = this.state;
    objState.object["idCommune"] = commune.gid;
    this.setState(objState);
  }

  /**
  * onCiviliteSelect
  * Modify the state idCivilite property from idCivilite Combobox change
  **/
  onCiviliteSelect(civilite) {
    let objState = this.state;
    objState.object["idCivilite"] = civilite.idCivilite;
    this.setState(objState);
  }

  geteDateTime(dateN) {
    if (dateN)
    {
      var date=new Date(dateN);
      //return date.getMonth();
      return date.getDate().toString().padStart(2, "0") + "/" + date.getMonth().toString().padStart(2, "0") + "/" + date.getFullYear() +", " + date.getHours().toString().padStart(2, "0") +":" + date.getMinutes().toString().padStart(2, "0");
    }
    return '';
  }

  openLink(){
    let objState = this.state;

    window.open(objState.object["url"], "_blank")
    //var win = window.open('http://nortekmed.dyndns.org/GPMG_BFI/Meteo', '_blank');


  }
  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idCapteur";
  }

  /**
  * handleDateEntreeChange
  * Modify the state dateEntree property from dateEntree field change
  **/
  handleDateServiceChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateService"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);

  }



  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.listeDiffusionsGrid !== undefined) this.refs.listeDiffusionsGrid.saveAll();
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let alerteObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.listeDiffusionsGrid !== undefined) alerteObj.listeDiffusions = this.refs.listeDiffusionsGrid.getArrayToSave();
    }

    // Validation des champs mails
    // if(alerteObj.listeDiffusions.length==0 && this.state.mode === "add") {
    //   this.setState({
    //     status: {
    //       type: 'danger',
    //       message: 'Il n\'y a aucun destinataire.'
    //     }
    //     });
    //
    //   return;
    // }

    let capteurObj = cloneObject(this.state.object);
    let state = this.state;

    // Validation des champs mails
    if(this.getMailValidationState("email1", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    if(this.getMailValidationState("email2", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail complémentaire n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    if(typeof capteurObj.date !== "string") {
      capteurObj.dateService = getStringFromDate(capteurObj.dateService);
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(capteurObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        const newObj = JSON.parse(response.entity);

        this.setState({
          status: {
            type: 'success',
            message: 'Capteur sauvegardé.'
          },
          object: newObj
        });

        if(this.props.onEdit) {
          this.props.onEdit.call(this, newObj);
        }
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Capteur créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/capteurs/" + newObj.idCapteur + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default Capteur;



// WEBPACK FOOTER //
// ./src/views/Entity/Capteur.js